// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","logo":"Header_logo__shVBB","navList":"Header_navList__rRxeY","link":"Header_link__qAkBV","activeLink":"Header_activeLink__VZiG4"};